import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { imgsTopic4 } from "../../../assets/imgs/Tema4";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	instructions: 3,
	activiy: 4,
	dialogTwo: 5,
	winSubactivityOne: 6,
}

export const Tema4SubtopicTwoActivityTwo = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema2], 2);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema2 activity 2");
			ObserverEmitter.emit(EVENTS.tema4.subtopicTwo.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.tema4.subtopicTwo.activityTwo.showSecondDialog, () => {
		setUiToShow(steps.dialogTwo)
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub02.sub2_act2_a02)
	})
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub02.sub2_act2_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicTwo.initScene, 2);
						setUiToShow(1)
						if (uiToShow >= 4) {
							ObserverEmitter.emit(EVENTS.tema4.subtopicTwo.activityTwo.hideKeyboard)
						}
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 2: Atajos del teclado." />
					<DialogBarNew
						dialog={
							"Ahora, te presentaré algunos atajos de teclado que te serán de gran ayuda para agilizar tus tareas diarias."
						}
						percentage={"50%"}
						callback={() => {
							setUiToShow(steps.viewActivities);
							ObserverEmitter.emit(EVENTS.tema4.subtopicTwo.activityOne.moveCameraOverDesk)
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Herramientas de la caja"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.instructions);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.instructions && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<PanelInstrucionHands
						text="Explora tocando las teclas iluminadas."
						action={() => {
							setUiToShow(steps.activiy);
							ObserverEmitter.emit(EVENTS.tema4.subtopicTwo.activityTwo.moveCameraOverKeyboard)
							ObserverEmitter.emit(EVENTS.tema4.subtopicTwo.activityTwo.showKeyboard)
						}}
						img={imgsTopic4.infoSub2Act2}
					/>
				</>
			)}
			{uiToShow === steps.activiy && (
				<>
					<BarStatusActivies activities={tasksList} />
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							"Has aprendido las teclas más importantes, revisa tu lista de actividades para saber la siguiente actividad."
						}
						percentage={"100%"}
						callback={() => {
							setUiToShow(steps.winSubactivityOne);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							// ObserverEmitter.emit(EVENTS.tema4.subtopicTwo.activityOne.moveCameraOverDesk)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.winSubactivityOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="No olvides mantener tus herramientas de trabajo en óptimas condiciones."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 10,
									subtema: tasksId.tema4.activities.subtema2,
								})
							);
							navigation("/home4/tema4/subtema2/results");
						}}
					/>
				</>
			)}

		</>

	)
}